import React, { PropsWithChildren } from "react";

import { PostHogProvider } from "posthog-js/react";

export const TrackingWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <PostHogProvider
      apiKey={"phc_GPFpM2rVdF5tPT0OfqjbD1pGHalzyGZbMaBZwQ2VYj3"}
      options={{
        api_host: "https://eu.i.posthog.com",
        autocapture: true,
        enable_heatmaps: true,
        capture_pageview: false,
        session_idle_timeout_seconds: 600,
        session_recording: {
          maskTextSelector: "#sensitive",
        },
      }}
    >
      {children}
    </PostHogProvider>
  );
};
